import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/loadFile/:fileName',
            component: Home,
            props: true
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js